import React from "react";
import { SERVICES, PRICING } from "../mock/mock";
import { ArrowUpRight } from "lucide-react";
import { useBooking } from "../context/BookingContext";

export default function Services() {
  const { openService } = useBooking();
  const list = SERVICES;
  const countItems = (i) => PRICING[i].groups.reduce((s, g) => s + g.items.length, 0);

  return (
    <section id="services" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="reveal text-center max-w-2xl mx-auto mb-12">
          <p className="section-line text-gold mb-4">Our Services</p>
          <h2 className="font-display text-4xl md:text-5xl font-medium leading-tight">
            The complete <span className="gold-gradient-text italic">VIIMII</span> therapy menu.
          </h2>
          <p className="mt-4 text-cream/60">Nails, lashes, mani-pedi, wax, skin, hair spa & massage - all under one luxe roof.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((s, i) => (
            <div
              key={s.id}
              onClick={() => openService(i)}
              className="reveal group relative rounded-[28px] overflow-hidden border hairline bg-viimii-2 cursor-pointer hover:border-gold transition-colors"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="h-56 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-7">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[11px] tracking-widest uppercase" style={{ color: "var(--viimii-clay)" }}>
                    {countItems(i)} options
                  </span>
                  <span className="text-xs text-cream/40">0{s.id}</span>
                </div>
                <h3 className="font-display text-2xl text-cream mb-2">{PRICING[i].cat}</h3>
                <p className="text-sm text-cream/60 leading-relaxed min-h-[60px]">{s.desc}</p>
                <div className="flex items-center justify-between mt-5 pt-5 border-t hairline">
                  <div>
                    <span className="text-xs text-cream/45 mr-1">{s.note}</span>
                    <span className="font-display text-2xl gold-gradient-text">{s.price}</span>
                  </div>
                  <span
                    className="inline-flex items-center gap-2 text-sm font-medium text-black px-4 py-2.5 rounded-full transition-all duration-300"
                    style={{ background: "var(--viimii-gold)" }}
                  >
                    Select <ArrowUpRight size={16} />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
